"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "longobardi": {
    "a892bcf8": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "ambricella": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f217355": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "campolevari": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c99d4ae3": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "frailiti": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "762fc2de": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "ranci": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7119c263": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "rigillo": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a759ac0a": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3a6b595b": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "santa-croce": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24c3d16f": [{
      "hkey": "a79ced57",
      "slug": "serra-d-ulivo",
      "name": "Serra d'Ulivo",
      "primary": true,
      "skipSearch": false
    }],
    "serra-olive": [{
      "hkey": "a79ced57",
      "slug": "serra-d-ulivo",
      "name": "Serra d'Ulivo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "37a48770": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "sirene": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f72c753": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "terra-rossa": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b4150cba": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "skipSearch": false
    }],
    "vardano": [{
      "hkey": "99d3ae59",
      "slug": "longobardi",
      "name": "Longobardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;